import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as filialService from "../../services/filialService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import Filial from '../../components/Filial';
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from "../../hooks/useMantenimiento";
import { setValidationMessage, activeValidations } from "../../redux/filialSlice";

const Edit = (props) => {
    const filial = useSelector((state) => state.filial.entity);

    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
    const dispatch = useDispatch();
    const params = useParams();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("filial");

    const messagesValidation = () => {
        const messages = [];

        if (!filial.codigo || filial.codigo.trim().length < 1) {
            messages.push("Falta ingresar el codigo de la filial");
        }
        if (!filial.nombre || filial.nombre.trim().length < 1) {
            messages.push("Falta ingresar el nombre de la filial");
        }
        if (!(filial.idDireccion > 0)) {
            messages.push("Falta elegir la direccion de la filial");
        }
        if (!(filial.idTipo > 0)) {
            messages.push("Falta elegir el tipo de la filial");
        }
        if (!(filial.idEstado > 0)) {
            messages.push("Falta elegir el estado de la filial");
        }

        return messages;
    }

    const postEntity = async () => {
        const validationMessages = messagesValidation();

        if (validationMessages.length > 0) {
            setPropsMessage({ severity: "error", message: validationMessages.join(" - ") })
            dispatch(setValidationMessage(validationMessages));
            dispatch(activeValidations());
            setOpenMessage(true);
            return;
        }

        await filialService.addUpdateFilial({ ...filial })
            .then(() => {
                setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
                setOpenMessage(true);
                setIsReadOnly(true);
            })
            .catch(() => {
                setPropsMessage({ severity: "error", message: "Hubo un error" })
                setOpenMessage(true);
            });
    }

    return (
        <div>
            <MantenimientoForm
                title={(params.id == 0 ? "Nuevo" : "Editar") + " Filial"}
                backTo={"/filial"}
                onSave={postEntity}
                disabled={isReadOnly}
            >
                <Grid container spacing={1} sx={{
                    "& .MuiGrid-root>.MuiGrid-item": {
                        paddingTop: "8px"
                    },
                }}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                <Filial isReadOnly={isReadOnly} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={6000} onClose={onCloseMessage}>
                <Alert severity={propsMessage.severity} onClose={onCloseMessage}>{propsMessage.message}</Alert>
            </Snackbar>
        </div>
    );
}
export default Edit;